import { useRoutes } from "react-router-dom";
import CreateCard from "../../Component/CreateCard.js"
import EditFormRoute from "../../Component/Forms/EditFormRoute.js"

import AddSuggestedSchools from "./SuggestedSchools/Create.js"
import SuggestedSchools from "./SuggestedSchools/View.js"

import AddHightSchool from "./HightSchool/Create.js"
import HightSchool from "./HightSchool/View.js"

import ProtectedRoute from "../RouteProtect.js"

const CarrierCardArray = [
    {
        title: "Hight School",
        path: "highSchool",
        auth: "carrier",
    },
    {
        title: "SuggestedSchools",
        path: "suggestedHighSchools",
        auth: "carrier",
    },
]


const RoutesArray = [
    {
        path: "/",
        element: <CreateCard cardJson={[...CarrierCardArray]} />
    },
    {
        path: "*",
        element: <h1>This is 404</h1>
    },
    {
        path: "suggestedHighSchools/*",
        element:
            (
                <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                    <SuggestedSchools />
                </ProtectedRoute>
            )
    },
    {
        path: "suggestedHighSchools/:id",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <EditFormRoute />
            </ProtectedRoute>
        )
    },
    {
        path: "suggestedHighSchools/addsuggestedHighSchools",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <AddSuggestedSchools />
            </ProtectedRoute>
        )
    },
    {
        path: "highSchool/*",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <HightSchool />
            </ProtectedRoute>
        )
    },
    {
        path: "highSchool/:id",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <EditFormRoute />
            </ProtectedRoute>
        )
    },
    {
        path: "highSchool/addhighSchool",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <AddHightSchool />
            </ProtectedRoute>
        )
    },
];


export default function MangeRoutes() {
    return useRoutes(RoutesArray)
};